/**
 * BackendConnectionAgentTag automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {TagAbstract, HttpRequest} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {AgentInput} from "./AgentInput";
import {AgentOutput} from "./AgentOutput";
import {CommonMessage} from "./CommonMessage";
import {CommonMessageException} from "./CommonMessageException";

export class BackendConnectionAgentTag extends TagAbstract {
    /**
     * Sends a message to an agent
     *
     * @returns {Promise<AgentOutput>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async send(connectionId: string, payload: AgentInput): Promise<AgentOutput> {
        const url = this.parser.url('/backend/connection/:connection_id/agent', {
            'connection_id': connectionId,
        });

        let request: HttpRequest = {
            url: url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            params: this.parser.query({
            }, [
            ]),
            data: payload
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as AgentOutput;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }



}
